import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { salespersonsPageDef } from '@/components/scm/scm-page-defs';

export default function ScmSalespersonsPage() {
  return <ScmPageRenderer pageDef={salespersonsPageDef} />;
}
